import { Avatar } from 'antd';
import React from 'react';
import { useTheme } from '@material-ui/core';
import useReduxState from '@portal/hooks/useReduxState';

interface AdvancedAvatarProps {
  name?: string;
  image?: string;
  backgroundColor?: string;
  color?: string;
  size?: number;
}

const AdvancedAvatar = ({
  name,
  image,
  backgroundColor = useTheme().palette.primary.main,
  color = useTheme().palette.getContrastText(backgroundColor),
  size = 40,
  ...rest
}: AdvancedAvatarProps) => {
  const {
    theme: { currentTheme },
  } = useReduxState();

  const style: React.CSSProperties = {
    backgroundColor: image ? undefined : backgroundColor,
    color: image ? undefined : color,
    fontWeight: 600,
    fontSize: 16,
  };

  const getInitials = (fullName: string) => {
    const namesArray = fullName.trim().split(' ');
    if (namesArray.length === 0) return '';
    if (namesArray.length === 1) return namesArray[0].charAt(0).toUpperCase();
    const firstInitial = namesArray[0].charAt(0).toUpperCase();
    const lastInitial = namesArray[namesArray.length - 1]
      .charAt(0)
      .toUpperCase();
    return firstInitial + lastInitial;
  };

  const initials = name ? getInitials(name) : '';

  return (
    <Avatar
      src={image}
      size={size}
      style={{ ...style, background: currentTheme.background }}
      {...rest}
    >
      {!image && initials}
    </Avatar>
  );
};

export default AdvancedAvatar;
